module.exports = __webpack_public_path__ + "static/img/weatherroute4.683ec68.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/product/weatherroute4.png
// module id = tmGL
// module chunks = 0